import React from "react";

// ui
import { FormFeedback, Label } from "reactstrap";
import RequiredIndicator from "./RequiredIndicator";
import Radio from "./Radio";

const RadioGroup = (props) => {
	const { error, label, name, onChange, radios, required, touched, value } =
		props;

	const invalid = required && touched && error ? true : false;
	const valid = required && touched && !error ? true : false;

	const styles = {
		display: invalid ? "block" : "none",
	};

	return (
		<React.Fragment>
			<Label>
				{label} {required && <RequiredIndicator />}
			</Label>
			{radios.map((radio) => (
				<Radio
					key={radio.value}
					name={name}
					label={radio.label}
					radioValue={radio.value}
					onChange={onChange}
					checked={radio.value === value}
					invalid={invalid}
					valid={valid}
				/>
			))}
			<FormFeedback valid={valid} style={styles}>
				{error}
			</FormFeedback>
		</React.Fragment>
	);
};

export default RadioGroup;
